var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "scan-result-full-screen-modal",
      attrs: {
        id: "scan-result-modal",
        centered: "",
        "header-class": "scan-result-modal-header"
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "div",
                { staticClass: "scan-result-modal-header-content step4 w-100" },
                [
                  _c("img", {
                    staticClass: "scan-result-modal-img",
                    attrs: {
                      src: _vm.isSuccess
                        ? require("@/assets/images/b122/ic_investigator_gifts.png")
                        : require("@/assets/images/b122/img-watcher-right.png")
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "scan-result-container h-100" }, [
                    _c("h1", {
                      class:
                        (_vm.isSuccess ? "green-o" : "red-o") +
                        " page-title ml-4 scan-result-modal-subtitle ",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.isSuccess
                            ? _vm.$t("scan.result.modal.success.title")
                            : _vm.$t("scan.result.modal.fail.title")
                        )
                      }
                    })
                  ])
                ]
              )
            ]
          }
        },
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            var cancel = ref.cancel
            var hide = ref.hide
            return [
              _c(
                "div",
                { staticClass: "w-100 d-flex" },
                [
                  _vm.shouldDisplayInsistButton
                    ? _c(
                        "b-button",
                        {
                          staticClass: "w-100 mr-2",
                          attrs: { variant: "secondary" },
                          on: {
                            click: function($event) {
                              return _vm.onInsistClicked($event)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex justify-content-center" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "align-self-center mt-small-px"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("scan.result.modal.fail.insist")
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100",
                      attrs: { variant: "primary" },
                      on: {
                        click: function($event) {
                          _vm.isSuccess
                            ? _vm.onVerifyClicked($event)
                            : _vm.onEndClicked($event)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.isSuccess
                                      ? _vm.$t(
                                          "scan.result.modal.success.button.text"
                                        )
                                      : _vm.$t("Finish")
                                  )
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      !_vm.isSuccess
        ? _c("div", [
            _vm.hasGainedLampion
              ? _c("p", { staticClass: "content" }, [
                  _vm._v(_vm._s(_vm.$t("scan.result.modal.fail.lampion.gain")))
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("p", { staticClass: "main-grey-light-color" }, [
              _vm._v(_vm._s(_vm.$t("scan.result.modal.fail.description")))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex align-items-center justify-content-center" },
        [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("scan.result.modal.information.given")))
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "card-plate mb-3" }, [
          _vm._v("\n      " + _vm._s(_vm.identifier) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _vm.shouldDisplayInsistButton
        ? _c("div", [
            _c("p", {
              staticClass: "content",
              domProps: {
                innerHTML: _vm._s(_vm.$t("scan.result.modal.fail.insist.text"))
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isSuccess
        ? _c("div", [
            _c("p", { staticClass: "bold-text main-red-color" }, [
              _vm._v(_vm._s(_vm.$t("scan.result.modal.caution")))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isSuccess || _vm.shouldDisplayInsistButton
        ? _c("div", [
            _c(
              "a",
              {
                staticClass: "main-color link",
                on: { click: _vm.onFraudClicked }
              },
              [_vm._v(_vm._s(_vm.$t("scan.result.modal.disclaimer")))]
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d3d74182", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3d74182","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/match/ScanResultModal.vue
// module id = wV2W
// module chunks = 0